import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const ApplyButton = forwardRef(({ title = 'Apply', className, ...props }, ref) => {
  const btnClassName = cn('apply-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='apply-button'
      responsive
      primary
      type='submit'
      className={btnClassName}
      title={title}
      {...props}
    />
  );
});

export default ApplyButton;
